import React from "react";

// Decorative right-hand panel shared by the login and signup pages,
// evoking architectural drafting sheets.
function AuthBrandPanel({ eyebrow, heading, tagline }) {
  return (
    <div className="auth-brand">
      <div className="auth-brand-content">
        <span className="auth-eyebrow">{eyebrow}</span>
        <h1>{heading}</h1>
        <p>{tagline}</p>
      </div>
    </div>
  );
}

export default AuthBrandPanel;
